import { useState } from "react";
import { incidentTypes } from "../config/formConfig";

export default function IncidentTypeSelector({ onSelect }) {
  const [selected, setSelected] = useState(null);

  const handleNext = () => {
    if (selected) onSelect(selected);
  };

  return (
    <div className="form-card">
      <h2 className="card-title">Select Incident Type</h2>
      <p className="card-subtitle">Choose the category that best describes the incident you are reporting.</p>

      <div className="type-grid">
        {incidentTypes.map((type) => (
          <button
            key={type.id}
            className={`type-card${selected?.id === type.id ? " selected" : ""}`}
            onClick={() => setSelected(type)}
          >
            <div className="type-card-label">{type.label}</div>
            <div className="type-card-code">{type.code.toUpperCase()}</div>
          </button>
        ))}
      </div>

      <div className="btn-row">
        <button className="btn-primary" disabled={!selected} onClick={handleNext}>
          Continue
        </button>
      </div>
    </div>
  );
}
